import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAgencySection from "../../components/agencies/FormAgencySection";
import { useGetAgencySection } from "../../hooks/agencies/useGetAgencySection";
import { useUpdateAgencySection } from "../../hooks/agencies/useUpdateAgencySection";

const AgencySection = () => {
    const { agencySection, isLoading: isFetching } = useGetAgencySection();
    const { mutate, isPending: isUpdating } = useUpdateAgencySection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAgencySection
                currentData={agencySection?.agency_section}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default AgencySection;
